import { useState } from "react";
import { Button, CloseButton, Modal } from "react-bootstrap";

const AppConfirm = (props) => {
  const {
    modaltitle,
    modalsubtitle,
    onSubmit,
    size,
    closeModal = "true",
    modalType = "confirm",
  } = props;
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmitClick = () => {
    setIsSubmitted(true);
    const timeout = setTimeout(() => {
      onSubmit();
      setIsSubmitted(false);
    }, 800);
    return () => clearTimeout(timeout);
  };
  
  return (
    <Modal
      {...props}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <div className="w-100" id="contained-modal-title-vcenter">
          <div className="col-md-12 col-sm-12 col-md-12 px-0 d-flex justify-content-between align-items-center">
            {modaltitle}
            {closeModal === "true" && <CloseButton onClick={props.onHide} />}
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>{modalsubtitle}</Modal.Body>
      {modalType === "alert" ? (
        <Modal.Footer className="border-0">
          <Button
            className="btn btn-cancel m-2"
            type="button"
            onClick={props.onHide}
          >
            CLOSE
          </Button>
        </Modal.Footer>
      ) : (
        <Modal.Footer className="border-0">
          <Button
            className="btn btn-cancel"
            type="button"
            onClick={props.onHide}
          >
            CANCEL
          </Button>
          <Button
            className="btn create-btn d-flex justify-content-center align-items-center"
            type="button"
            onClick={onSubmitClick}
          >
            PROCEED{" "}
            {isSubmitted ? (
              <div
                className="spinner-border spinner-border-sm text-light ms-1"
                role="status"
              ></div>
            ) : (
              ""
            )}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default AppConfirm;
